export default __webpack_public_path__ + "static/media/green-planet-grey.f46f8c1a.svg";